import { Button, Form, Space } from "antd";
import React from "react";
import { UI_ITOModuleSuccess, UI_ITOTooltip } from "../../../UI_ITO/indexUI";

interface IDraftButtons {
  isSuccessEdit: boolean;
  isLoadingArray: {
    isLoadingEdit: boolean;
    isLoadingEditAndToInWork: boolean;
  };
  changeApplication: (addToInWork: boolean) => void;
  isPassportNotIncludes: boolean;
}

export const DraftButtons: React.FC<IDraftButtons> = ({
  isSuccessEdit,
  isLoadingArray,
  changeApplication,
  isPassportNotIncludes,
}) => {
  return (
    <Form name="buttonsChangeApplication">
      <Space>
        <UI_ITOModuleSuccess
          title="Изменения успешно сохранены"
          isSuccess={isSuccessEdit}
        />
        <Button
          htmlType="submit"
          style={{ color: "#3C79FF", borderColor: "#3C79FF" }}
          onClick={() => changeApplication(false)}
          loading={isLoadingArray.isLoadingEdit}
        >
          Сохранить
        </Button>
        <UI_ITOTooltip title={isPassportNotIncludes ? "Загрузите паспорт" : ""}>
          <Button
            type="primary"
            htmlType="submit"
            onClick={() => changeApplication(true)}
            disabled={isPassportNotIncludes}
            loading={isLoadingArray.isLoadingEditAndToInWork}
          >
            Сохранить и отправить в работу
          </Button>
        </UI_ITOTooltip>
      </Space>
    </Form>
  );
};
